import React, { useState } from "react";
import { TextField, PrimaryButton, Stack, MessageBar, MessageBarType } from "@fluentui/react";
import axios from "axios";

const SignInForm = (props) => {
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [errorMessage, setErrorMessage] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);

  const handleInputChange = (event, newValue) => {
    const { name } = event.target;
    setFormData((prev) => ({ ...prev, [name]: newValue }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setErrorMessage(null);
    setSuccessMessage(null);

    try {
      const response = await axios.post("/api/sign-in", {
        email: formData.email,
        password: formData.password,
      });

      setSuccessMessage("Sign-in successful!");
      localStorage.setItem('wlp-token', response.data.token);
      setFormData({ email: "", password: "" }); // Reset the form
      props.successCallback && props.successCallback(); // if theres a success callback, try again
      
    } catch (error) {
      setErrorMessage(error.response?.data?.error || "An error occurred while signing in.");
    }
  };

  return (
    <Stack
      tokens={{ childrenGap: 15, padding: 20 }}
      styles={{ root: { maxWidth: 400, margin: "auto" } }}
    >
      <h2>Sign In</h2>
      {errorMessage && (
        <MessageBar messageBarType={MessageBarType.error} isMultiline={false}>
          {errorMessage}
        </MessageBar>
      )}
      {successMessage && (
        <MessageBar messageBarType={MessageBarType.success} isMultiline={false}>
          {successMessage}
        </MessageBar>
      )}

      <TextField
        label="Email"
        name="email"
        type="email"
        value={formData.email}
        onChange={handleInputChange}
        required
      />
      <TextField
        label="Password"
        name="password"
        type="password"
        value={formData.password}
        onChange={handleInputChange}
        required
      />
      <PrimaryButton text="Sign In" onClick={handleSubmit} />
      {props.children}
    </Stack>
  );
};

export default SignInForm;
